<template>
  <v-container class="helmi-group-dashboard pt-4" :class="{ 'dark': theme === 'dark' }">
    <!-- <v-row>
      <v-col
        cols="12"
      >
        <helmi-group-dashboard-listings :colors="colors"/>
      </v-col>
    </v-row> -->

    <v-row>
      <v-col
        cols="12"
      >
        <helmi-group-dashboard-office-selector :colors="colors"/>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <helmi-group-dashboard-offices :colors="colors"/>
      </v-col>

      <v-col cols="12" md="6">
        <helmi-group-dashboard-yearly-pie/>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <helmi-group-dashboard-cumulative-return/>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <helmi-group-dashboard-monthly-return/>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <helmi-group-dashboard-yearly-pie-per-month/>
      </v-col>

      <v-col
        cols="12"
        md="6"
      >
        <helmi-group-dashboard-agents :colors="colors"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'GroupDashboard',

  components: {

    'helmi-group-dashboard-agents':
      () => import('@/components/groupDashboard/GroupDashboardAgents'),
    'helmi-group-dashboard-offices': () => import('@/components/groupDashboard/GroupDashboardOffices'),
    'helmi-group-dashboard-office-selector': () => import('@/components/groupDashboard/GroupDashboardOfficeSelector'),
    'helmi-group-dashboard-cumulative-return': () => import('@/components/groupDashboard/GroupDashboardCumulativeReturn'),
    'helmi-group-dashboard-monthly-return': () => import('@/components/groupDashboard/GroupDashboardMonthlyReturn'),
    'helmi-group-dashboard-yearly-pie': () => import('@/components/groupDashboard/GroupDashboardYearlyPie'),
    'helmi-group-dashboard-yearly-pie-per-month': () => import('@/components/groupDashboard/GroupDashboardYearlyPiePerMonth'),
  },

  data: () => ({
    colors: [
      'primary lighten-2',
      'purple lighten-2',
      'pink lighten-2',
      'light-blue lighten-2',
      'teal lighten-2',
    ],
  }),

  computed: {
    ...mapState({
      theme: 'theme',
    }),
  },

  methods: {},
};
</script>

<style lang="scss">
.helmi-group-dashboard {
  height: 100%;

  &.dark {
    background: #2c2945;
  }

  .v-list-item {
    animation-duration: 800ms;
    animation-fill-mode: both;
    animation-iteration-count: 1;
    animation-name: fadeIn;
    animation-timing-function: cubic-bezier(0.0, 0.0, 0.2, 1);

    .list-ornament {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 4px;
    }
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
      transform: translateX(-16px);
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }

  .h-list__group {
    overflow: hidden;
  }
}
</style>
